export const getUserDetail = (key) => {
  // const userInfo = sessionStorage.getItem("userData");
  const userInfo = localStorage.getItem("userData");
  if (userInfo) {
    const convertData = JSON.parse(userInfo);
    //return the actual Key
    return convertData[key];
  }
  return null;
};
